import { render, staticRenderFns } from "./ParametersTab.vue?vue&type=template&id=49a773eb&scoped=true&"
import script from "./ParametersTab.vue?vue&type=script&lang=js&"
export * from "./ParametersTab.vue?vue&type=script&lang=js&"
import style0 from "./ParametersTab.vue?vue&type=style&index=0&id=49a773eb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a773eb",
  null
  
)

export default component.exports